export const SET_CURRENT_EVENT_OPERATOR = 'SET_CURRENT_EVENT_OPERATOR';

export const setCurrentEventOperator = (eventOperator) => ({
    type: SET_CURRENT_EVENT_OPERATOR,
    eventOperator: eventOperator,
});

